import axios from 'axios';

const API_BASE_URL = 'https://backend.gouniquejourneys.co.uk/api/employee/complaints'; // Adjust if needed


export const getAssignedComplaints = async (  page, limit, sortOrder ) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/all-complaints`, {

      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      params: {  page, limit, sortOrder }, // Send filters as query params
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching assigned flight bookings:", error.response?.data || error.message);
    throw error;
  }
};

export const addCommentComplaints= async (conversationData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/add-comment-complaint`, conversationData, {
        
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding conversation:', error.response?.data || error.message);
    throw error;
  }
};

export const updateComplaintAgent = async (complaintId, updatedData) => {
  try {
    const response = await axios.put(`${API_BASE_URL}/update-complaint-agent/${complaintId}`, updatedData, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating tour booking:', error.response?.data || error.message);
    throw error;
  }
};

export const updateComplaint = async (queryId, updatedData) => {
    try {
      const response = await axios.put(`${API_BASE_URL}/update-complaint/${queryId}`, updatedData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating query:', error.response?.data || error.message);
      throw error;
    }
  };